import { Route, Redirect } from "react-router-dom";
import { useUser } from "../../hooks/useUser";
import { useHistory } from "react-router";

function PrivateRoute({ component: Component, path, location, ...rest }) {
  const { user } = useUser();
  const history = useHistory();

  // const user = {};



  return (
    <Route
      {...rest}
      path={path}

      render={(props) => (

        !user ? (
          history.replace({
            pathname: '/login',
            search: `redirectTo=${location?.pathname}`
          })
          // <Redirect to="/login" {...props}/>
        ) : (
          <Component {...props} />
        )
      )}

    />
  );
}

export default PrivateRoute;
